import React from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import { useRealTimeStreamingColumns } from '../../hooks/useRealTimeStreamingColumns';

export default function StreamingTable({
  data,
  sortBy,
  setSortBy,
  changePageInfo,
  pageInfo,
  loading,
  total,
  isCCV,
  filter,
  rankTimeList,
  isGST,
}: {
  filter: any;
  data: any;
  sortBy: any;
  setSortBy: any;
  changePageInfo: any;
  pageInfo: any;
  loading: any;
  total: any;
  isCCV: boolean;
  rankTimeList: {
    newTime: string[];
    oldTime: string[];
  };
  isGST?: boolean;
}) {
  const { columns } = useRealTimeStreamingColumns({
    isCCV,
    filter,
    pageInfo,
    rankTimeList,
    isGST,
  });

  return (
    <TableCommonHook
      className="dbo-streaming-table-common"
      recordKey="live_id"
      records={data}
      sortColumns={['rank', 'live_time', 'live_viewer']}
      sortInfo={[sortBy, setSortBy]}
      pageInfo={pageInfo}
      setPageInfo={changePageInfo}
      columns={columns as any}
      loading={loading}
      total={total}
    />
  );
}
